import { Region, RegionFallbackLanguageMap } from '@lemon8/web-app-shared/i18n';

const defaultParams = {
  os: 'android',
  ac: 'WIFI',
  dpi: '440',
  aid: '2876', // TODO change aid
  brand: 'samsung',
  tz_name: 'Asia/Tokyo',
  youtube: 1,
  channel: 'wap',
  tz_offset: 19800,
  resolution: '1920*1080',
  os_version: 10,
  web_source: 'wap',
  app_version: '10.6.0',
  device_type: 'wap',
  version_code: '10600',
  device_brand: 'samsung',
  hevc_supported: 1,
  device_platform: 'wap',
  original_channel: 'wap',
  update_version_code: '106000',
  manifest_version_code: '10600',
};

const generateData = (data: Record<string, any>): string => {
  const params = [];
  for (const [key, value] of Object.entries(data)) {
    // stringify 过滤掉undefined和null
    if (value !== null) {
      if (value === true) {
        params.push(encodeURIComponent(key));
      } else if (typeof value === 'object') {
        const value_str = JSON.stringify(value);
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value_str)}`);
      } else {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
  }
  return params.join('&');
};

const parseRes = async (res: Response) => {
  const contentType = res.headers.get('Content-Type');
  // 判定返回的内容类型，做不同的处理
  if (contentType) {
    if (contentType.includes('json')) {
      return await res.json();
    }
    if (contentType.includes('text')) {
      return await res.text();
    }
    if (contentType.includes('form')) {
      return await res.formData();
    }
    if (contentType.includes('video')) {
      return await res.blob();
    }
  }
  return await res.text();
};

const handleRes = async (res: Response | undefined) => {
  if (!res) {
    return '';
  }

  const parsedRes = await parseRes(res);
  // 如果res.ok，则请求成功
  if (res.ok) {
    return parsedRes;
  }
  // 请求失败，返回解析之后的失败的数据
  const error = parsedRes;
  throw error;
};

export enum HttpMethod {
  get = 'GET',
  post = 'POST',
}

export interface FetchConfig {
  isFormData?: boolean;
  headers?: HeadersInit;
  method?: HttpMethod;
  params: Record<string, any>;
}

export const _fetch = async (
  url: string,
  config: FetchConfig = {
    headers: {},
    params: {},
  },
  props: {
    region: Region;
    addCommonParams: boolean;
  },
): Promise<Response> => {
  let reqUrl = `/${url}`.replace('//', '/');

  const region = props.region.toString();
  const language = RegionFallbackLanguageMap[props.region].toString();
  const commonParams = {
    ...defaultParams,
    region,
    language,
  };

  let resPromise: Response | undefined;

  if (!config.method || config.method === HttpMethod.get) {
    reqUrl +=
      (reqUrl.indexOf('?') === -1 ? '?' : '&') +
      generateData({
        ...(props.addCommonParams ? commonParams : {}),
        ...config.params,
      });

    resPromise = await fetch(reqUrl, {
      headers: config.headers,
    });
  }

  if (config.method === HttpMethod.post) {
    if (props.addCommonParams) {
      reqUrl += (reqUrl.indexOf('?') === -1 ? '?' : '&') + generateData({ ...commonParams });
    }

    // 表单上传fetch
    if (config.isFormData) {
      const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        ...config.headers,
      };

      const body = new FormData();
      Object.keys(config.params).forEach((key) => {
        body.append(key, config.params[key]);
      });

      resPromise = await fetch(reqUrl, {
        headers,
        body,
        method: HttpMethod.post,
      });
    } else {
      const headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...config.headers,
      };

      resPromise = await fetch(reqUrl, {
        headers,
        body: JSON.stringify(config.params),
        method: HttpMethod.post,
      });
    }
  }

  return handleRes(resPromise);
};
